idd_addEvent(window,'load',function() { if (document.getElementById('securityLogin')) { document.getElementById('securityLogin').focus();}})
